export const FALLBACK_IMAGES = {
  default: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=800&q=80',
  article: 'https://images.unsplash.com/photo-1532012197267-da84d127e765?w=800&q=80',
  video: 'https://images.unsplash.com/photo-1576097449798-7c7f90e1248a?w=800&q=80',
};

export const getRandomFallbackImage = (type?: string): string => {
  if (type === 'video') return FALLBACK_IMAGES.video;
  if (type === 'article') return FALLBACK_IMAGES.article;
  return FALLBACK_IMAGES.default;
};